// @flow

import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { IMAGE_PATH } from '../util/config';
import { logGAEvent } from '../util/log-ga';
import mapFacebookResponse from '../util/map-facebook-response';
import { ensureFBInit } from '../util/facebook-api';

declare var FB: any;

const styles = () => ({
  facebookButton: {
    backgroundColor: '#4267B2',
    backgroundImage: `url(${IMAGE_PATH}/FB-f-Logo__white_29.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '8px 8px',
    color: 'white',
    minWidth: '250px',
    paddingLeft: 50,
    padding: '10px 10px 10px 50px',
  },
});

interface Props extends WithStyles<typeof styles> {
  applyCallback: Function,
  t: (value: string, opts?: any) => string,
}

type State = {
  loginInfo: ?Object,
  applicant: ?Object,
  fbLoaded: boolean,
}

/* eslint-disable */
const loadFB = (d, s, id) => {
  let js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {return;}
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
};
/* eslint-enable */

const getPersonDetails = (callback: Function) => {
  FB.api('/me', { fields: 'first_name, last_name, email' }, (response) => {
    callback(response);
  });
};

class FacebookLogin extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loginInfo: null,
      applicant: null,
      fbLoaded: false,
    };
  }

  componentDidMount() {
    ensureFBInit().then(() => {
      FB.getLoginStatus(this.statusChangeCallback);
    });
  }

  statusChangeCallback = (statusResponse: FacebookLoginResponse) => {
    // If the user is already logged into our app and facebook
    if (statusResponse.status === 'connected') {
      getPersonDetails((personResponse) => {
        this.setState({
          fbLoaded: true,
          loginInfo: statusResponse,
          applicant: personResponse,
        });
      });
    } else {
      this.setState({
        fbLoaded: true,
      });
    }
  };

  submitLogin = (applicant: FacebookUser, loginInfo: FacebookLoginResponse) => {
    this.props.applyCallback(mapFacebookResponse(applicant, loginInfo));
  }

  login = () => {
    if (!this.state.loginInfo || !this.state.applicant) {
      FB.login((loginResponse) => {
        if (loginResponse.status === 'connected') {
          getPersonDetails((userResponse) => {
            this.submitLogin(userResponse, loginResponse);
          });
        }
      }, {
        scope: 'email',
      });
    } else {
      this.submitLogin(this.state.applicant, this.state.loginInfo);
    }
    logGAEvent('Application', 'Clicked Apply with Facebook');
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <Button
          disabled={!this.state.fbLoaded}
          className={classes.facebookButton}
          variant="contained"
          onClick={this.login}
        >
          {t('continueWithFacebook')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(FacebookLogin));
